import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

import { AppWrap, MotionWrap } from '../../wrapper';
import './About.scss';
//permet de récuperer les infos de sanity
import { urlFor, client } from '../../client';

const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]';

    client.fetch(query).then((data) => {
      setAbouts(data);
    });
  }, []);
  
  
  // const abouts = [
// {title : 'Web Designer', description: 'What separates design from art is that design is meant to be... functional ― cameron moll', imgUrl:images.about02},
// {title : 'React Developeur', description: 'I have fallen in love with react framework and trying to do as much project with it, as I can', imgUrl:images.reactApp},
// {title : 'Frontend Developeur', description: 'There are three responses to a piece of design - yes, no, and WOW! Wow is the one to aim for” - Milton Glaser', imgUrl:images.about01},
// {title : 'Backend Developeur', description: 'It´s better to wait for a productive programmer to become available than it is to wait for the first available programmer to become productive. - Steve McConnell', imgUrl:images.about04},
// ];


  return (
    <>
      <h2 className="head-text">My passion is to <span>create</span> <br />what  <span>you imagine</span></h2>

      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>{about.title}</h2>
            <p className="p-text" style={{ marginTop: 10 }}>{about.description}</p>
          </motion.div>
        ))}
      </div>
    </>
  );
};
export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg',
);

  

